import config from '../config'

export const AUTH_APIS = {
  autoLogin: `${config.apiUrl}/api/auto_login`,
  login: `${config.apiUrl}/api/login`,
  forgetPassword: `${config.apiUrl}/api/forget_password`,
}
